import { render, staticRenderFns } from "./ReplySection.vue?vue&type=template&id=b5133e38&"
import script from "./ReplySection.vue?vue&type=script&lang=js&"
export * from "./ReplySection.vue?vue&type=script&lang=js&"
import style0 from "./ReplySection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports